import { render, staticRenderFns } from "./MyMemberships.vue?vue&type=template&id=40fafed5"
import script from "./MyMemberships.vue?vue&type=script&lang=js"
export * from "./MyMemberships.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports